/**
 * Account Search Bar Component
 *
 * Renders search input and platform filter.
 */

import React from 'react';
import { Input, Select, SelectItem } from '@heroui/react';
import type { Platform } from '@/entities/account';

interface AccountSearchBarProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  selectedPlatform: Platform | 'all';
  onPlatformChange: (platform: Platform | 'all') => void;
  className?: string;
}

export const AccountSearchBar: React.FC<AccountSearchBarProps> = ({
  searchTerm,
  onSearchChange,
  selectedPlatform,
  onPlatformChange,
  className = '',
}) => {
  return (
    <div className={`flex flex-wrap gap-4 ${className}`}>
      <div className="flex-grow min-w-[250px]">
        <Input
          type="text"
          placeholder="계정명으로 검색..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          classNames={{
            input: 'bg-white',
            inputWrapper: 'bg-white border border-gray-300',
          }}
        />
      </div>
      <div className="flex space-x-3">
        <Select
          selectedKeys={[selectedPlatform]}
          onSelectionChange={(keys) => onPlatformChange(Array.from(keys)[0] as Platform | 'all')}
          classNames={{
            trigger: 'bg-white border border-gray-300',
          }}
          className="w-40"
          aria-label="플랫폼 필터"
        >
          <SelectItem key="all">모든 플랫폼</SelectItem>
          <SelectItem key="INSTAGRAM">Instagram</SelectItem>
          <SelectItem key="YOUTUBE">YouTube</SelectItem>
          <SelectItem key="TIKTOK">TikTok</SelectItem>
        </Select>
      </div>
    </div>
  );
};

AccountSearchBar.displayName = 'AccountSearchBar';
